import { Constants } from "config/constants";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import AccountSettings from "components/lib/Shared/CompanyDashboard/AccessTab";
import AssignPermission from "./AssignPermission";
import Invites from "components/lib/Shared/CompanyDashboard/Invites";
import Tabs from "components/lib/Shared/Tabs";
import { Roles_Permissions_Constants } from "config/roles-permissions";

const initialTabs = [{ id: "access", name: "Access" }];

const DashboardAccessRequests = ({ currentUserIsEmployee }) => {
  const [generalTabs, setGeneralTabs] = useState(initialTabs);
  const [selectedTab, setSelectedTab] = useState(initialTabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const { organization, dashboardRoles, dashboardPermissions } = useSelector(
    (state) => state.organizationsSlice
  );

  useEffect(() => {
    const isNotVOR = dashboardRoles?.every(
      (role) => role.name !== Roles_Permissions_Constants.DASHBOARD_ROLES.VOR
    );
    const isApprover = dashboardRoles?.some(
      (role) =>
        role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.APPROVER
    );
    const canManageUsers = dashboardPermissions.some(
      (permission) =>
        permission.name ===
        Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.MANAGE_USERS
    );

    let genTabs = [];

    if (!isNotVOR) {
      setGeneralTabs([]);
    }
    if (isApprover) {
      genTabs.push(
        { id: "invites", label: "Invites" },
        { id: "access", label: "Access" }
      );
    }

    if (canManageUsers) {
      genTabs.push({ id: "assign", label: "Assign" });
    }

    setGeneralTabs(genTabs);
  }, [dashboardRoles, dashboardPermissions]);

  useEffect(() => {
    const tempSelectedTab = generalTabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [generalTabs, selectedTabIndex]);

  return (
    <div className="grid gap-4 mx-auto">
      <h4 className="text-sflPrimary text-xl font-medium">Access control</h4>
      <Tabs
        tabs={generalTabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        showTooltip
      />
      <div className="grid grid-cols-12">
        <div className="col-span-12 md:col-span-11 pt-2">
          {selectedTab.id === "invites" && <Invites />}
          {selectedTab.id === "access" && (
            <AccountSettings
              page="ORGANIZATION_DASHBOARD"
              organization={organization}
              dashboardRoles={dashboardRoles}
              currentUserIsEmployee={currentUserIsEmployee}
            />
          )}
          {selectedTab.id === "assign" && <AssignPermission />}
        </div>
      </div>
    </div>
  );
};

export default DashboardAccessRequests;
